import { ICurrenciesValue } from './dashboard'

export interface IColdWallets {
	balances: ICurrenciesValue
	links: { [coin: string]: string }
}

export class ColdWallets {
	balances: ICurrenciesValue = {}
	links: { [coin: string]: string } = {}
}


// WEBPACK FOOTER //
// ./src/models/coldWallets.ts